export default __webpack_public_path__ + "static/receptiviti-dark-theme-de82f47afb4dcfc2473df8ba64a87f24.png";